import { useForm } from '@/Contexts';
import get from 'lodash/get';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import { InertiaFormProps } from '@inertiajs/react';

export const useFormInput = <T>(name: string) => {
    const form = useForm();

    if (!form) {
        throw new Error('useFormInput must be used within a FormProvider');
    }

    return {
        value: get(form.data, name) as T | undefined,
        setValue: (value: T) => form.setData((data: any) => set(cloneDeep(data), name, value)),
        error: form.errors[name]
    };
};

export const useDynamicInputs = <TData extends Record<string, unknown>|null>(name: string, empty: TData, form?: InertiaFormProps<any>|null) => {
    form ??= useForm();

    if (!form) {
        throw new Error('useDynamicInput must be used within a FormProvider');
    }

    const addValue = () => {
        const currentValue = get(form.data, name) as TData[] | undefined;
        const newValue = [...(currentValue ?? []), empty];
        form.setData((data: any) => set(cloneDeep(data), name, newValue));
    };

    const removeValue = (index: number) => {
        const currentValue = get(form.data, name) as TData[] | undefined;
        const newValue = currentValue?.filter((_, i) => i !== index);
        form.setData((data: any) => set(cloneDeep(data), name, newValue));
    };

    return {
        addValue,
        removeValue,
        values: get(form.data, name) as TData[] | undefined,
    };
};
